/* ==========================================================================
   MI-NY — Kit Picker
   Selettore di prodotti da comporre in un kit (es. "scegli 3 colori").

   Scelte di progetto
   ------------------
   1. Non fa una propria chiamata /cart/add.js. Scrive input nascosti
      (properties[...]) dentro il form del tema e lascia inviare il tema:
      eredita cart drawer, gestione errori, analytics e traduzioni.

   2. Il catalogo si carica solo alla prima apertura della modale, via
      /collections/<handle>/products.json, e resta in cache condivisa.
      Non pesa sull'HTML della scheda prodotto.

   3. Lo swatch è la foto reale del prodotto: nessun metafield colore da
      popolare su centinaia di referenze.

   4. Selezione a due tempi (desktop e mobile): il clic sullo swatch porta il
      colore in anteprima, l'assegnazione allo slot avviene solo con il
      pulsante sotto l'anteprima. Serve perche' il pulsante agisce sul colore
      in anteprima: con l'assegnazione al passaggio del mouse bastava sfiorare
      un altro swatch per cambiare bersaglio e confermare il colore sbagliato.
      La rimozione ha due strade equivalenti: lo stesso pulsante (che diventa
      "Rimuovi") e il badge "x" sullo swatch gia' scelto.

   5. Intercetta il submit in fase di CAPTURE su document, così arriva prima
      del listener di <product-form> del tema.
   ========================================================================== */
(function () {
  'use strict';

  if (customElements.get('kit-picker')) return;

  /* Cache condivisa fra istanze: la stessa collection si scarica una volta */
  var CACHE = {};

  var CLOSE_SVG = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
    '<path d="M18.75 5.13L5.25 18.85" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/>' +
    '<path d="M18.75 18.85L5.25 5.13" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/></svg>';

  /* Conserva le scelte fin dove c'e' posto: chi passa dal kit da 4 a quello
     da 2 non deve ricominciare, chi sale trova gli slot nuovi vuoti. */
  function resize(a, n) {
    var out = new Array(n), i;
    for (i = 0; i < n; i++) out[i] = i < a.length ? a[i] : null;
    return out;
  }

  function sized(src, width) {
    if (!src) return '';
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  function stripHtml(html) {
    if (!html) return '';
    var d = document.createElement('div');
    d.innerHTML = html;
    return (d.textContent || '').replace(/\s+/g, ' ').trim();
  }

  class KitPicker extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;

      this.inline = this.dataset.inline === 'true';
      this.collection = this.dataset.collection;
      this.slots = parseInt(this.dataset.slots, 10) || 3;
      this.label = this.dataset.label || 'Colore';
      /* Famiglie: 'Etichetta|tag' oppure solo 'tag' (etichetta = tag).
         Serve perché i tag reali del catalogo sono spesso tecnici e
         illeggibili per il cliente finale. */
      this.families = (this.dataset.families || '')
        .split(',')
        .map(function (s) { return s.trim(); })
        .filter(Boolean)
        .map(function (s) {
          var i = s.indexOf('|');
          return i > -1
            ? { l: s.slice(0, i).trim(), k: s.slice(i + 1).trim().toLowerCase() }
            : { l: s, k: s.toLowerCase() };
        });

      /* Stato */
      this.items = null;
      this.picked = new Array(this.slots).fill(null);
      this.draft = new Array(this.slots).fill(null);
      this.active = 0;
      this.preview = null;   // indice in anteprima
      this.previewImg = 0;   // immagine corrente del colore in anteprima
      this.filter = '';
      this.query = '';
      this.pendingSubmit = false;

      /* Nodi */
      this.dialog = this.querySelector('[data-mkp-dialog]');
      if (!this.dialog) return;

      this.grid = this.querySelector('[data-mkp-grid]');
      this.chips = this.querySelector('[data-mkp-chips]');
      this.search = this.querySelector('[data-mkp-search]');
      this.slotsEl = this.querySelector('[data-mkp-slots]');
      this.confirmBtn = this.querySelector('[data-mkp-confirm]');
      this.progress = this.querySelector('[data-mkp-progress]');
      this.chosen = this.querySelector('[data-mkp-chosen]');
      this.cta = this.querySelector('.mkp-cta');
      this.media = this.querySelector('[data-mkp-media]');
      this.strip = this.querySelector('[data-mkp-strip]');
      this.actionBtn = this.querySelector('[data-mkp-action]');
      this.hint = this.querySelector('[data-mkp-hint]');
      this.pName = this.querySelector('[data-mkp-pname]');
      this.pDesc = this.querySelector('[data-mkp-pdesc]');
      this.pLink = this.querySelector('[data-mkp-plink]');
      this.navPrev = this.querySelector('[data-mkp-prev]');
      this.navNext = this.querySelector('[data-mkp-next]');
      this.elLoading = this.querySelector('[data-mkp-loading]');
      this.elEmpty = this.querySelector('[data-mkp-empty]');
      this.elError = this.querySelector('[data-mkp-error]');
      this.fieldLabel = this.querySelector('[data-mkp-label]');
      this.fieldState = this.querySelector('[data-mkp-state]');
      this.note = this.querySelector('[data-mkp-note]');

      /* Righe separate. Oltre alla bandierina del tema si accende con
         ?righe=1 nell'indirizzo: serve a provare il flusso sul negozio vero
         senza accenderlo per i clienti, finche' la funzione sconto non e'
         pubblicata (senza di lei i colori si pagherebbero). */
      this.split = this.dataset.split === 'true' ||
        /[?&]righe=1(&|$)/.test(window.location.search);

      this.form =
        document.getElementById('product-form-' + this.dataset.section) ||
        document.querySelector('form[data-type="add-to-cart-form"][data-product-id="' + this.dataset.productId + '"]') ||
        this.closest('form[data-type="add-to-cart-form"]');

      /* Quanti colori chiede ciascuna variante (kit unificato) */
      this.vslots = {};
      var vs = this.querySelector('[data-mkp-vslots]');
      if (vs) {
        try { this.vslots = JSON.parse(vs.textContent); } catch (e) { this.vslots = {}; }
      }

      this.injectFields();
      this.bind();

      var n = this.slotsForCurrentVariant();
      if (n && n !== this.slots) {
        this.slots = n;
        this.picked = resize(this.picked, n);
        this.draft = resize(this.draft, n);
      }
      this.buildSlotEls();
      this.renderTexts();
      /* Allinea subito il contatore: il Liquid ha stampato il numero della
         variante predefinita del prodotto, che puo' non essere quella scelta. */
      this.renderFoot();
      this.watchVariant();
      this.styleVariantCards();
      this.renderSummary();
      if (this.inline) this.setupInline();
    }

    /* ------------------------------------------------------------------
       Modalita' inline: niente modale, il selettore sta nel buybox
       ------------------------------------------------------------------ */
    setupInline() {
      var self = this;
      if (this.cta) this.cta.hidden = true;
      this.draft = this.picked.slice();
      this.active = 0;

      /* Il catalogo pesa qualche centinaio di kB: si scarica quando il
         selettore sta per entrare nello schermo, non al caricamento della
         pagina, cosi' non rallenta la scheda per chi non arriva a scegliere. */
      if ('IntersectionObserver' in window) {
        this._io = new IntersectionObserver(function (e) {
          if (!e[0].isIntersecting) return;
          self._io.disconnect();
          self._io = null;
          self.load();
        }, { rootMargin: '300px' });
        this._io.observe(this);
      } else {
        this.load();
      }
    }

    /* Inline non ha un pulsante "Conferma": la scelta vale subito, quindi il
       modulo va tenuto allineato a ogni tocco. */
    commitInline() {
      if (!this.inline) return;
      this.picked = this.draft.slice();
      this.writeFields();
      /* Scrivi gli attributi carrello solo quando la selezione è completa */
      if (this.isComplete()) this.writeCartAttributes();
    }

    /* Invio bloccato perche' mancano colori: invece di aprire una modale che
       non c'e' piu', porta il selettore sotto gli occhi. */
    nudge() {
      try {
        this.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } catch (e) {
        this.scrollIntoView();
      }
      var el = this.slotsEl;
      if (!el) return;
      el.classList.remove('is-nudge');
      void el.offsetWidth;
      el.classList.add('is-nudge');
    }

    /* ------------------------------------------------------------------
       Variante selezionata -> numero di colori
       ------------------------------------------------------------------ */
    variantInput() {
      return this.form ? this.form.querySelector('[name="id"]') : null;
    }

    slotsForCurrentVariant() {
      var inp = this.variantInput();
      if (!inp) return 0;
      var v = this.vslots[String(inp.value)];
      if (!v) return 0;
      /* Retrocompatibile: prima la mappa era {id: numero}, ora {id: {n,p,...}} */
      var n = typeof v === 'object' ? v.n : v;
      return n ? parseInt(n, 10) : 0;
    }

    /* ------------------------------------------------------------------
       Veste i selettori di variante del tema come nel prototipo: card con
       titolo grande e prezzo sotto. Il meccanismo resta del tema — sono
       sempre i suoi radio, qui si aggiunge solo una classe, l'etichetta
       leggibile e il prezzo. Cosi' non duplichiamo la logica delle varianti.
       ------------------------------------------------------------------ */
    styleVariantCards() {
      if (!this.form) return;
      var vs = document.getElementById('variant-selects-' + this.dataset.section) ||
               document.querySelector('variant-selects[data-section="' + this.dataset.section + '"]') ||
               document.querySelector('variant-selects');
      if (!vs) return;
      vs.classList.add('mkp-cards');

      var self = this;
      Array.prototype.forEach.call(vs.querySelectorAll('fieldset'), function (fs) {
        var legend = fs.querySelector('legend');
        if (!legend) return;

        /* L'etichetta vera sta fra parentesi: "Base Kit Peel Off (Quantita'
           smalti)" -> "Quantita' smalti". Il resto e' nomenclatura interna
           del bundle e al cliente non dice niente. */
        var raw = (legend.textContent || '').split(':')[0].trim();
        var par = raw.match(/\(([^)]+)\)/);
        var label = par ? par[1].trim() : raw;
        var kind = /quantit|smalt/i.test(label) ? 'qty' : 'conf';
        if (kind === 'qty') label = 'Smalti inclusi';
        fs.dataset.mkpOpt = kind;

        var box = legend.firstElementChild || legend;

        if (!legend.querySelector('.mkp-cards__t')) {
          var b = document.createElement('b');
          b.className = 'mkp-cards__t';
          b.textContent = label;
          box.insertBefore(b, box.firstChild);
        }

        /* Configurazione: al posto del valore selezionato (che la card gia'
           mostra) il link alla spiegazione, come nel prototipo. */
        if (kind === 'conf' && self.note && !legend.querySelector('.mkp-help')) {
          var h = document.createElement('button');
          h.type = 'button';
          h.className = 'mkp-help';
          h.textContent = 'Quale scegliere?';
          h.addEventListener('click', function (e) {
            e.preventDefault();
            self.openNote();
          });
          box.appendChild(h);
        }
      });

      this.updateCardPrices();
    }

    /* ------------------------------------------------------------------
       Riquadro "Quale scegliere?"
       ------------------------------------------------------------------ */
    openNote() {
      if (!this.note) return;
      if (typeof this.note.showModal === 'function') {
        try { this.note.showModal(); return; } catch (e) { /* gia' aperto */ }
      }
      this.note.setAttribute('open', '');
    }

    closeNote() {
      if (!this.note) return;
      if (typeof this.note.close === 'function') {
        try { this.note.close(); return; } catch (e) { /* niente */ }
      }
      this.note.removeAttribute('open');
    }

    /* Il prezzo sotto ogni card dipende anche dall'altra opzione: cambiando
       "con lampada" cambiano i prezzi di tutte le quantita'. */
    updateCardPrices() {
      var self = this;
      var vs = document.querySelector('variant-selects.mkp-cards');
      if (!vs || !this.vslots) return;

      var cur = this.vslots[String((this.variantInput() || {}).value)] || null;
      if (!cur || typeof cur !== 'object') return;

      /* La posizione dell'opzione la da' l'ordine dei fieldset, non un
         indice fisso: in admin le opzioni si possono riordinare, e o1 puo'
         essere la lampada come la quantita'. */
      var fss = vs.querySelectorAll('fieldset');
      Array.prototype.forEach.call(fss, function (fs, pos) {
        var kind = fs.dataset.mkpOpt;
        var key = 'o' + (pos + 1);

        Array.prototype.forEach.call(fs.querySelectorAll('input[type="radio"]'), function (inp) {
          var lab = fs.querySelector('label[for="' + inp.id + '"]');
          if (!lab) return;

          /* Variante di questa card, con le ALTRE opzioni ferme su quelle
             attualmente selezionate. */
          var match = self.findVariant(key, inp.value, cur);
          if (!match) return;

          var txt;
          if (kind === 'qty') {
            txt = match.p;
          } else {
            /* Differenziale rispetto all'opzione piu' economica, non fra le
               due card: cosi' la base non porta scritto niente e l'altra dice
               quanto costa in piu'. Mostrare "-39 €" sulla card scelta era
               solo confondente. */
            var min = null, j;
            for (j in self.vslots) {
              var w = self.vslots[j];
              if (typeof w !== 'object' || !self.sameExcept(w, cur, key)) continue;
              var c = self.cents(w.p);
              if (min === null || c < min) min = c;
            }
            var d = min === null ? 0 : self.cents(match.p) - min;
            if (d > 0) {
              txt = '+ ' + (d / 100).toFixed(2).replace('.', ',') + ' €';
            } else if (/senza/i.test(inp.value || '')) {
              /* L'opzione base non ha un sovrapprezzo da mostrare: al suo posto
                 la ragione per sceglierla, come nel prototipo. */
              txt = 'Hai già una LED';
            } else {
              txt = '';
            }
          }

          var s = lab.querySelector('.mkp-card__s');
          if (!s) {
            s = document.createElement('span');
            s.className = 'mkp-card__s';
            lab.appendChild(s);
          }
          s.textContent = txt;
        });
      });
    }

    /* Cerca la variante che ha `val` sull'opzione `key` e lascia invariate
       tutte le altre opzioni rispetto a quella selezionata ora. */
    findVariant(key, val, cur) {
      for (var k in this.vslots) {
        var v = this.vslots[k];
        if (typeof v !== 'object') continue;
        if (v[key] !== val) continue;
        if (this.sameExcept(v, cur, key)) return v;
      }
      return null;
    }

    sameExcept(a, b, key) {
      var keys = ['o1', 'o2', 'o3'], i;
      for (i = 0; i < keys.length; i++) {
        if (keys[i] === key) continue;
        if ((a[keys[i]] || null) !== (b[keys[i]] || null)) return false;
      }
      return true;
    }

    cents(money) {
      var n = String(money).replace(/[^\d,.]/g, '').replace(/\.(?=\d{3}\b)/g, '').replace(',', '.');
      return Math.round(parseFloat(n || '0') * 100);
    }

    /* I temi cambiano la variante in modi diversi: alcuni emettono un evento,
       altri riscrivono `input.value` da JS, che non fa scattare ne' `change`
       ne' il MutationObserver (cambia la proprieta', non l'attributo). Si
       ascoltano tutte le strade e si tiene un controllo periodico leggero
       come rete di sicurezza: legge un valore, non tocca il DOM. */
    watchVariant() {
      var self = this;
      var inp = this.variantInput();
      if (!inp) return;

      var sync = function () {
        var n = self.slotsForCurrentVariant();
        if (n && n !== self.slots) self.setSlots(n);
        /* Il tema rigenera i radio a ogni cambio variante: le card vanno
           rivestite, ed e' idempotente. */
        self.styleVariantCards();
      };

      inp.addEventListener('change', sync);
      if (this.form) this.form.addEventListener('change', sync);
      try {
        this._mo = new MutationObserver(sync);
        this._mo.observe(inp, { attributes: true, attributeFilter: ['value'] });
      } catch (e) { /* niente */ }
      ['variant:change', 'variantChange', 'product:variant-change'].forEach(function (ev) {
        document.addEventListener(ev, sync);
      });
      this._evs = sync;
      this._poll = setInterval(sync, 500);
    }

    setSlots(n) {
      if (!n || n === this.slots) return;
      this.slots = n;
      this.picked = resize(this.picked, n);
      this.draft = resize(this.draft, n);
      var free = this.draft.indexOf(null);
      this.active = free > -1 ? free : 0;

      this.buildSlotEls();
      this.renderTexts();
      this.renderSlots();
      this.renderGrid();
      this.renderFoot();
      this.renderAction();
      this.renderSummary();
      this.writeFields();
    }

    buildSlotEls() {
      if (!this.slotsEl) return;
      var html = '', i;
      for (i = 0; i < this.slots; i++) {
        html += '<div class="mkp-slot-wrap">' +
          '<button class="mkp-slot" type="button" data-slot="' + i + '"' +
          ' aria-current="' + (i === this.active ? 'true' : 'false') + '"' +
          ' aria-label="' + this.label + ' ' + (i + 1) + ': da scegliere">' +
          '<span class="mkp-slot__n">' + (i + 1) + '</span></button>' +
          '<button class="mkp-slot__x" type="button" data-slot-clear="' + i + '" hidden' +
          ' aria-label="Rimuovi ' + this.label.toLowerCase() + ' ' + (i + 1) + '">' +
          CLOSE_SVG + '</button></div>';
      }
      this.slotsEl.innerHTML = html;
    }

    /* Titolo della modale e invito nella scheda seguono il numero di colori */
    renderTexts() {
      var one = this.slots === 1;
      var h = this.querySelector('.mkp-head__h');
      if (h) h.textContent = one ? 'Scegli il tuo colore' : 'Scegli i tuoi ' + this.slots + ' colori';
      var b = this.querySelector('.mkp-cta__tx b');
      if (b) b.textContent = one ? 'Scegli la tua tonalità' : 'Scegli le tue tonalità';
      /* L'etichetta segue la variante: cambiando "Smalti inclusi" cambia
         anche il numero di colori annunciato qui. */
      if (this.fieldLabel) {
        this.fieldLabel.textContent = one ? 'Il tuo colore' : 'I tuoi ' + this.slots + ' colori';
      }
      this.renderState();
    }

    /* Stato a destra dell'etichetta: "Da scegliere" oppure "N di M scelti" */
    renderState() {
      if (!this.fieldState) return;
      var n = 0, i;
      for (i = 0; i < this.slots; i++) {
        if (this.picked[i] !== null && this.picked[i] !== undefined) n++;
      }
      this.fieldState.textContent = n === 0
        ? 'Da scegliere'
        : n + ' di ' + this.slots + (this.slots === 1 ? ' scelto' : ' scelti');
    }

    /* ------------------------------------------------------------------
       Input nascosti dentro il form del tema
       ------------------------------------------------------------------ */
    injectFields() {
      var tpl = this.querySelector('template[data-mkp-fields]');
      if (!tpl || !this.form) return;
      this.fields = [];
      var self = this;
      var nodes = tpl.content.cloneNode(true).querySelectorAll('input');
      Array.prototype.forEach.call(nodes, function (input) {
        /* Nascono disabilitati: li accende writeFields() solo per i colori
           effettivamente scelti sulla variante corrente. */
        input.disabled = true;
        self.form.appendChild(input);
        if (input.name.indexOf('_kit_ids') > -1) self.idsField = input;
        else if (input.name.indexOf('[_kit]') > -1) self.kitField = input;
        else self.fields.push(input);
      });
    }

    /* ------------------------------------------------------------------
       Eventi
       ------------------------------------------------------------------ */
    bind() {
      var self = this;

      this.querySelectorAll('[data-mkp-open]').forEach(function (b) {
        b.addEventListener('click', function () { self.open(false); });
      });

      this.querySelectorAll('[data-mkp-close]').forEach(function (b) {
        b.addEventListener('click', function () { self.dialog.close(); });
      });

      /* Riquadro "Quale scegliere?": chiusura dal pulsante e dal fondale */
      if (this.note) {
        this.querySelectorAll('[data-mkp-note-close]').forEach(function (b) {
          b.addEventListener('click', function () { self.closeNote(); });
        });
        this.note.addEventListener('click', function (e) {
          if (e.target === self.note) self.closeNote();
        });
      }

      this.confirmBtn.addEventListener('click', function () { self.confirm(); });

      /* Il pulsante sotto l'anteprima: assegna o rimuove il colore mostrato */
      if (this.actionBtn) {
        this.actionBtn.addEventListener('click', function () { self.applyAction(); });
      }

      this.search.addEventListener('input', function () {
        self.query = self.search.value.trim().toLowerCase();
        self.renderGrid();
      });

      /* Slot: ascolto delegato, perche' gli slot vengono ricostruiti a ogni
         cambio di variante e i listener sui singoli nodi andrebbero persi. */
      if (this.slotsEl) {
        this.slotsEl.addEventListener('click', function (e) {
          var clear = e.target.closest('[data-slot-clear]');
          if (clear) {
            e.stopPropagation();
            var k = parseInt(clear.dataset.slotClear, 10);
            self.draft[k] = null;
            self.active = k;
            self.afterDraftChange();
            return;
          }
          var s = e.target.closest('.mkp-slot');
          if (!s) return;
          self.active = parseInt(s.dataset.slot, 10);
          self.renderSlots();
          /* Cambia il bersaglio, quindi cambia anche il testo del pulsante:
             "Scegli" su slot libero, "Sostituisci" su slot occupato. */
          self.renderAction();
        });
      }

      /* Navigazione fra le foto del colore in anteprima */
      if (this.navPrev) {
        this.navPrev.addEventListener('click', function () { self.stepImage(-1); });
      }
      if (this.navNext) {
        this.navNext.addEventListener('click', function () { self.stepImage(1); });
      }

      if (this.strip) {
        this.strip.addEventListener('scroll', function () { self.syncStripIndex(); }, { passive: true });
      }

      /* Intercetta l'invio del form finché la selezione non è completa */
      if (this.form) {
        this._onSubmit = function (e) {
          if (e.target !== self.form) return;

          /* Selezione incompleta: si porta il cliente a scegliere. */
          if (!self.isComplete()) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            if (self.inline) self.nudge();
            else self.open(true);
            return;
          }

          /* Righe separate: prima si aggiungono i colori, poi si lascia fare
             al tema, che aggiunge il kit e aggiorna il carrello. Il secondo
             giro passa di qui con la bandierina alzata e non fa niente. */
          if (!self.split || self._coloriInviati) return;
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          if (self.cta) self.cta.setAttribute('aria-busy', 'true');
          self.aggiungiColori().then(function () {
            self._coloriInviati = true;
            if (typeof self.form.requestSubmit === 'function') self.form.requestSubmit();
            else self.form.submit();
            self._coloriInviati = false;
          }).catch(function (err) {
            /* Se i colori non entrano non deve entrare nemmeno il kit:
               meglio un carrello vuoto che un kit senza smalti. */
            self.erroreColori(err);
          }).then(function () {
            if (self.cta) self.cta.removeAttribute('aria-busy');
          });
        };
        document.addEventListener('submit', this._onSubmit, true);
      }

      /* Chiusura: ripristina lo stato transitorio */
      this.dialog.addEventListener('close', function () {
        self.pendingSubmit = false;
      });
    }

    disconnectedCallback() {
      if (this._onSubmit) document.removeEventListener('submit', this._onSubmit, true);
      if (this._poll) clearInterval(this._poll);
      if (this._mo) this._mo.disconnect();
      if (this._evs) {
        ['variant:change', 'variantChange', 'product:variant-change'].forEach(function (ev) {
          document.removeEventListener(ev, this._evs);
        }, this);
      }
    }

    isComplete() {
      return this.picked.every(function (v) { return v !== null; });
    }

    /* ------------------------------------------------------------------
       Apertura + caricamento pigro del catalogo
       ------------------------------------------------------------------ */
    open(fromSubmit) {
      this.pendingSubmit = !!fromSubmit;
      this.draft = this.picked.slice();
      var next = this.draft.indexOf(null);
      this.active = next > -1 ? next : 0;
      this.query = '';
      this.search.value = '';

      this.renderSlots();
      this.renderFoot();
      this.renderAction();

      /* Inline il pannello e' gia' aperto e in flusso: showModal lo porterebbe
         nel top layer con tanto di sfondo scuro. */
      if (!this.inline) {
        if (this.dialog.showModal) this.dialog.showModal();
        else this.dialog.setAttribute('open', '');
      }

      this.load();
    }

    load() {
      var self = this;

      if (this.items) { this.renderGrid(); return; }

      this.elLoading.hidden = false;
      this.elError.hidden = true;

      if (!CACHE[this.collection]) {
        var url = '/collections/' + encodeURIComponent(this.collection) + '/products.json?limit=250';
        CACHE[this.collection] = fetch(url, { headers: { Accept: 'application/json' } })
          .then(function (r) {
            if (!r.ok) throw new Error('HTTP ' + r.status);
            return r.json();
          })
          .then(function (data) {
            return (data.products || []).map(function (p) {
              var imgs = [];
              if (p.images && p.images.length) {
                imgs = p.images.slice(0, 4).map(function (im) { return im.src || im; });
              } else if (p.featured_image) {
                imgs = [p.featured_image];
              }

              var available = false;
              if (p.variants && p.variants.length) {
                available = p.variants.some(function (v) { return v.available; });
              }

              var desc = stripHtml(p.body_html);
              if (desc.length > 110) desc = desc.slice(0, 110).replace(/\s+\S*$/, '') + '…';

              /* Id della variante da mettere nel carrello: la prima
                 disponibile, altrimenti la prima. Serve solo in modalita'
                 righe separate, ma costa niente portarselo sempre. */
              var vid = null;
              if (p.variants && p.variants.length) {
                var scelta = p.variants.filter(function (v) { return v.available; })[0] || p.variants[0];
                vid = scelta && scelta.id;
              }

              return {
                t: p.title,
                h: p.handle,
                v: vid,
                imgs: imgs,
                a: available,
                d: desc,
                tags: (p.tags || []).map(function (x) { return String(x).toLowerCase(); })
              };
            });
          });
      }

      CACHE[this.collection]
        .then(function (list) {
          self.items = list;
          self.elLoading.hidden = true;
          self.buildChips();
          self.buildGrid();
          self.renderSlots();
          self.renderAction();
        })
        .catch(function () {
          self.elLoading.hidden = true;
          self.elError.hidden = false;
          delete CACHE[self.collection];
        });
    }

    /* ------------------------------------------------------------------
       Costruzione interfaccia
       ------------------------------------------------------------------ */
    buildChips() {
      if (!this.families.length || this.chips.children.length) return;
      var self = this;
      var all = [{ k: '', l: 'Tutti' }].concat(this.families);

      all.forEach(function (f) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'mkp-chip';
        b.textContent = f.l;
        b.dataset.k = f.k;
        b.setAttribute('aria-pressed', f.k === '' ? 'true' : 'false');
        b.addEventListener('click', function () {
          self.filter = f.k;
          Array.prototype.forEach.call(self.chips.children, function (c) {
            c.setAttribute('aria-pressed', c.dataset.k === f.k ? 'true' : 'false');
          });
          self.renderGrid();
        });
        self.chips.appendChild(b);
      });
    }

    buildGrid() {
      if (this._built) { this.renderGrid(); return; }
      this._built = true;

      var self = this;
      var frag = document.createDocumentFragment();
      var closeSvg = CLOSE_SVG;

      this.items.forEach(function (it, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'mkp-item';
        b.dataset.i = i;
        b.setAttribute('aria-pressed', 'false');
        b.setAttribute('aria-label', it.t + (it.a ? '' : ' — esaurito'));
        if (!it.a) b.dataset.soldout = 'true';

        var html = '';
        if (it.tags.indexOf('bestseller') > -1) {
          html += '<span class="mkp-item__best">Bestseller</span>';
        }
        /* Il badge di rimozione sta FUORI dallo swatch: lo swatch ha
           overflow:hidden per ritagliare la foto nel cerchio e lo
           clipperebbe. Il contenitore ne fissa la larghezza e lo centra. */
        html += '<span class="mkp-item__c">';
        html += '<span class="mkp-item__sw">';
        if (it.imgs.length) {
          html += '<img src="' + sized(it.imgs[0], 200) + '" alt="" loading="lazy" width="100" height="100">';
        }
        html += '</span>';
        html += '<span class="mkp-item__x">' + closeSvg + '</span>';
        html += '</span>';
        html += '<span class="mkp-item__n">' + it.t + '</span>';
        b.innerHTML = html;

        /* Un solo gesto, due esiti: sul badge "x" rimuove, altrove mette in
           anteprima. Nessuna anteprima al passaggio del mouse: il pulsante di
           conferma agisce sul colore in anteprima e il mouse che lo raggiunge
           attraversa altri swatch. */
        b.addEventListener('click', function (e) {
          if (e.target.closest && e.target.closest('.mkp-item__x')) {
            self.showPreview(i);
            self.removeItem(i);
            return;
          }
          self.showPreview(i, true);
        });
        frag.appendChild(b);
      });

      this.grid.appendChild(frag);
      this.renderGrid();
    }

    /* ------------------------------------------------------------------
       Anteprima
       ------------------------------------------------------------------ */
    /* focusAction: dopo un clic sullo swatch il fuoco va sul pulsante di
       conferma, cosi' da tastiera il percorso resta Invio -> Invio invece di
       costringere a risalire tutta la griglia. preventScroll evita lo scatto
       della modale su mobile. */
    showPreview(i, focusAction) {
      if (this.preview !== i) {
        this.preview = i;
        this.previewImg = 0;
        this.renderPreview();
      }
      this.renderAction();

      if (focusAction && this.actionBtn && !this.actionBtn.disabled) {
        try {
          this.actionBtn.focus({ preventScroll: true });
        } catch (e) {
          this.actionBtn.focus();
        }
      }
    }

    /* Le frecce non cambiano piu' il src: fanno scorrere la striscia, cosi'
       il gesto col dito e quello col mouse portano allo stesso posto. */
    stepImage(dir) {
      if (!this.strip) return;
      var slides = this.strip.children;
      if (slides.length < 2) return;
      var n = this.previewImg + dir;
      if (n < 0) n = slides.length - 1;
      if (n > slides.length - 1) n = 0;
      this.previewImg = n;
      if (this.strip.scrollTo) {
        this.strip.scrollTo({ left: slides[n].offsetLeft, behavior: 'smooth' });
      } else {
        this.strip.scrollLeft = slides[n].offsetLeft;
      }
    }

    /* Tiene allineato l'indice quando si scorre col dito, altrimenti la
       freccia successiva ripartirebbe dalla prima foto. */
    syncStripIndex() {
      if (!this.strip || !this.strip.firstElementChild) return;
      var w = this.strip.firstElementChild.offsetWidth || 1;
      this.previewImg = Math.round(this.strip.scrollLeft / w);
    }

    renderPreview() {
      if (this.preview === null || !this.items) return;
      var it = this.items[this.preview];

      if (this.hint) this.hint.hidden = true;

      if (this.strip) {
        this.strip.innerHTML = '';
        it.imgs.forEach(function (src, k) {
          var slide = document.createElement('div');
          slide.className = 'mkp-slide';
          var im = document.createElement('img');
          im.src = sized(src, 900);
          im.alt = k === 0 ? it.t : '';
          im.loading = k === 0 ? 'eager' : 'lazy';
          slide.appendChild(im);
          this.strip.appendChild(slide);
        }, this);
        this.strip.dataset.count = it.imgs.length;
        this.strip.scrollLeft = 0;
        this.previewImg = 0;
      }

      var many = it.imgs.length > 1;
      if (this.navPrev) this.navPrev.hidden = !many;
      if (this.navNext) this.navNext.hidden = !many;

      if (this.pName) this.pName.textContent = it.t;
      if (this.pDesc) this.pDesc.textContent = it.d ? ' — ' + it.d : '';
      if (this.pLink) {
        this.pLink.href = '/products/' + it.h;
        this.pLink.hidden = false;
      }

      Array.prototype.forEach.call(this.grid.querySelectorAll('.mkp-item'), function (b) {
        b.dataset.preview = 'false';
      });
      var cur = this.grid.querySelector('.mkp-item[data-i="' + this.preview + '"]');
      if (cur) cur.dataset.preview = 'true';
    }

    /* ------------------------------------------------------------------
       Selezione — secondo tempo: il pulsante sotto l'anteprima
       ------------------------------------------------------------------ */
    applyAction() {
      if (this.preview === null || !this.items) return;

      var i = this.preview;
      if (this.draft.indexOf(i) > -1) {
        this.removeItem(i);
        return;
      }

      var it = this.items[i];
      if (!it || !it.a) return;

      /* Va sempre nello slot attivo: e' quello evidenziato in alto, quindi
         il bersaglio e' visibile prima del clic. Se sono tutti pieni,
         sostituisce quello attivo invece di bloccare la scelta. */
      this.draft[this.active] = i;
      var next = this.draft.indexOf(null);
      if (next > -1) this.active = next;

      this.afterDraftChange();
    }

    removeItem(i) {
      var at = this.draft.indexOf(i);
      if (at < 0) return;
      this.draft[at] = null;
      this.active = at;
      this.afterDraftChange();
    }

    afterDraftChange() {
      this.commitInline();
      this.renderSlots();
      this.renderGrid();
      this.renderFoot();
      this.renderAction();
    }

    /* Tre stati: nessuna anteprima (spento), colore libero (assegna),
       colore gia' in uno slot (rimuove). */
    renderAction() {
      var b = this.actionBtn;
      if (!b) return;

      if (this.preview === null || !this.items) {
        b.disabled = true;
        b.dataset.mode = 'pick';
        b.textContent = 'Scegli questo colore';
        return;
      }

      var at = this.draft.indexOf(this.preview);
      if (at > -1) {
        b.disabled = false;
        b.dataset.mode = 'remove';
        b.textContent = this.slots === 1
          ? 'Rimuovi il colore'
          : 'Rimuovi il colore ' + (at + 1);
        return;
      }

      if (!this.items[this.preview].a) {
        b.disabled = true;
        b.dataset.mode = 'pick';
        b.textContent = 'Tonalità esaurita';
        return;
      }

      b.disabled = false;
      if (this.draft[this.active] === null) {
        b.dataset.mode = 'pick';
        b.textContent = 'Scegli questo colore';
      } else {
        /* Modo a se': la sostituzione e' correttiva e convive a schermo con
           "Conferma". Due pulsanti pieni identici costringerebbero a leggerli
           per capire quale porta al carrello. */
        b.dataset.mode = 'replace';
        b.textContent = this.slots === 1
          ? 'Sostituisci il colore'
          : 'Sostituisci il colore ' + (this.active + 1);
      }
    }

    renderGrid() {
      if (!this.items) return;
      var self = this;
      var shown = 0;

      Array.prototype.forEach.call(this.grid.querySelectorAll('.mkp-item'), function (b) {
        var it = self.items[+b.dataset.i];
        var okF = !self.filter || it.tags.indexOf(self.filter) > -1;
        var okQ = !self.query || it.t.toLowerCase().indexOf(self.query) > -1;
        var vis = okF && okQ;
        b.hidden = !vis;
        if (vis) shown++;
        b.setAttribute('aria-pressed', self.draft.indexOf(+b.dataset.i) > -1 ? 'true' : 'false');
      });

      this.elEmpty.hidden = shown > 0;
    }

    renderSlots() {
      var self = this;
      this.querySelectorAll('.mkp-slot').forEach(function (s) {
        var i = parseInt(s.dataset.slot, 10);
        var v = self.draft[i];
        var clear = self.querySelector('[data-slot-clear="' + i + '"]');

        s.setAttribute('aria-current', i === self.active ? 'true' : 'false');

        if (v === null || !self.items) {
          s.classList.remove('is-filled');
          s.style.backgroundImage = '';
          s.setAttribute('aria-label', self.label + ' ' + (i + 1) + ': da scegliere');
          if (clear) clear.hidden = true;
        } else {
          var it = self.items[v];
          s.classList.add('is-filled');
          s.style.backgroundImage = it.imgs.length ? 'url(' + sized(it.imgs[0], 140) + ')' : '';
          s.setAttribute('aria-label', self.label + ' ' + (i + 1) + ': ' + it.t);
          if (clear) clear.hidden = false;
        }
      });
    }

    renderFoot() {
      var n = this.draft.filter(function (v) { return v !== null; }).length;
      var manca = this.slots - n;
      this.progress.textContent = n + ' / ' + this.slots;
      this.confirmBtn.disabled = manca > 0;

      /* Su mobile la barra di conferma e' legata a questa classe: resta fuori
         schermo finche' non c'e' niente da confermare. */
      this.dialog.classList.toggle('is-complete', manca === 0);

      if (manca > 0) {
        /* Con un solo slot "Scegline ancora 1" suona sbagliato */
        this.confirmBtn.textContent = this.slots === 1
          ? 'Scegli un colore'
          : 'Scegline ancora ' + manca;
      } else {
        this.confirmBtn.textContent = this.pendingSubmit
          ? 'Conferma e aggiungi al carrello'
          : 'Conferma';
      }
    }

    /* ------------------------------------------------------------------
       Conferma
       ------------------------------------------------------------------ */
    confirm() {
      if (this.draft.some(function (v) { return v === null; })) return;

      var self = this;
      this.picked = this.draft.slice();
      this.writeFields();
      this.renderSummary();

      /* Scrivi gli attributi carrello con i colori scelti.
         Fire-and-forget: non blocca il flusso, non aspetta la risposta.
         Il carrello potrebbe non avere ancora il kit (viene aggiunto dopo),
         ma gli attributi persistono sul carrello fino al checkout. */
      this.writeCartAttributes();

      var submit = this.pendingSubmit;
      if (!this.inline) this.dialog.close();

      this.dispatchEvent(new CustomEvent('kit-picker:change', {
        bubbles: true,
        detail: { items: this.picked.map(function (i) { return self.items[i]; }) }
      }));

      if (submit && this.form) {
        var btn = this.form.querySelector('.product-form__submit');
        if (this.form.requestSubmit) this.form.requestSubmit(btn || undefined);
        else this.form.submit();
      }
    }

    /* Gli input nascosti sono tanti quanti ne chiede la variante piu' capiente.
       Quelli oltre il numero di colori della variante corrente si svuotano:
       Shopify ignora le properties vuote, quindi non sporcano il carrello. */
    writeFields() {
      if (!this.fields) return;
      var self = this;
      this.fields.forEach(function (input, i) {
        var idx = self.picked[i];
        var ok = i < self.slots && idx !== null && idx !== undefined && self.items;
        input.value = ok ? self.items[idx].t : '';
        /* Disabilitato, non solo vuoto: un input vuoto viene comunque inviato
           e in carrello resta "Colore 3: " senza valore, che poi ricompare
           nell'email di conferma e nell'ordine in admin. Gli input disabilitati
           non entrano nella FormData. */
        input.disabled = !ok;
      });

      /* Gli id delle varianti scelte: li legge la funzione di espansione o,
         in modalita' righe separate, servono a ricostruire il legame.
         Finora il campo veniva creato ma non riempito. */
      if (this.idsField) {
        var ids = [];
        for (var i = 0; i < this.slots; i++) {
          var k = this.picked[i];
          var it = (k === null || k === undefined || !this.items) ? null : this.items[k];
          if (it && it.v) ids.push(it.v);
        }
        this.idsField.value = ids.join(',');
        this.idsField.disabled = ids.length === 0;
      }
    }

    /* ------------------------------------------------------------------
       Attributi carrello — colori kit
       Scrive attributes[Colori Kit <NomeKit>] nel carrello via /cart/update.js
       così il valore finisce in order.note_attributes e Order Printer lo legge.

       Strategia multi-kit:
       - Chiave: "Colori Kit" se il titolo del kit è generico, altrimenti
         "Colori Kit <NomeKit>" (es. "Colori Kit Peel Off Lac").
         Il nome del kit viene da data-kit-title (impostato dallo snippet Liquid).
       - Valore: "Colore 1: MILLENNIAL PINK, Colore 2: NUDE, ..."
       - /cart/update.js con attributes fa un MERGE: aggiorna solo la chiave
         propria, non tocca le chiavi di altre app (freegift, BOGO, ecc.).
       - Chiamata fire-and-forget: un eventuale fallimento non blocca il checkout.
       ------------------------------------------------------------------ */
    writeCartAttributes() {
      if (!this.isComplete() || !this.items) return Promise.resolve();

      /* Costruisce la stringa "Colore 1: X, Colore 2: Y, ..." */
      var self = this;
      var label = this.label || 'Colore';
      var parts = [];
      for (var i = 0; i < this.slots; i++) {
        var k = this.picked[i];
        if (k !== null && k !== undefined && this.items[k]) {
          parts.push(label + ' ' + (i + 1) + ': ' + this.items[k].t);
        }
      }
      if (!parts.length) return Promise.resolve();
      var coloriStr = parts.join(', ');

      /* Chiave attributo: include il nome del kit per supportare multi-kit
         nello stesso ordine senza collisioni. */
      var kitTitle = (this.dataset.kitTitle || '').trim();
      var attrKey = kitTitle ? 'Colori Kit ' + kitTitle : 'Colori Kit';

      var attrs = {};
      attrs[attrKey] = coloriStr;

      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: attrs })
      }).then(function (r) {
        if (!r.ok) {
          /* Non blocca il flusso: logga solo in console */
          console.warn('[MI-NY kit-picker] writeCartAttributes: HTTP ' + r.status);
        }
        return r.json().catch(function () { return null; });
      }).catch(function (err) {
        console.warn('[MI-NY kit-picker] writeCartAttributes:', err);
      });
    }

    /* ------------------------------------------------------------------
       Righe separate: il kit entra normalmente e ogni colore scelto entra
       come riga a se'. Le righe colore partono a prezzo pieno — e' questo
       che fa scendere il magazzino dello smalto — e la discount function
       "Smalti inclusi nel kit" le porta a zero.
       Spento finche' la funzione non e' pubblicata: senza di lei il cliente
       pagherebbe gli smalti.
       ------------------------------------------------------------------ */
    codiceKit() {
      return 'kit-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8);
    }

    quantitaKit() {
      var q = this.form && this.form.querySelector('[name="quantity"]');
      var n = q ? parseInt(q.value, 10) : 1;
      return n > 0 ? n : 1;
    }

    aggiungiColori() {
      var self = this;
      var ids = [];
      for (var i = 0; i < this.slots; i++) {
        var k = this.picked[i];
        var it = (k === null || k === undefined || !this.items) ? null : this.items[k];
        if (it && it.v) ids.push(it.v);
      }
      if (ids.length !== this.slots) {
        return Promise.reject(new Error('Manca l\'id di qualche colore.'));
      }

      /* Lo stesso codice va sulla riga del kit e su quelle dei colori: e'
         l'unico legame che la funzione sconto puo' verificare. */
      var codice = this.codiceKit();
      if (this.kitField) {
        this.kitField.value = codice;
        this.kitField.disabled = false;
      }

      var q = this.quantitaKit();
      var titolo = this.dataset.kitTitle || 'kit';
      var items = ids.map(function (id) {
        return {
          id: id,
          quantity: q,
          properties: { _kit: codice, 'Incluso nel': titolo }
        };
      });

      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        if (r.ok) return r.json();
        return r.json().then(function (j) {
          throw new Error(j.description || j.message || ('HTTP ' + r.status));
        }, function () {
          throw new Error('HTTP ' + r.status);
        });
      });
    }

    erroreColori(err) {
      var box = this.querySelector('[data-mkp-errore]');
      if (!box) return;
      box.textContent = (err && err.message) || 'Non riusciamo ad aggiungere i colori scelti.';
      box.hidden = false;
    }

    renderSummary() {
      var done = this.isComplete();
      this.renderState();
      /* Inline il selettore e' gia' a schermo: invito e riepilogo sarebbero
         due doppioni dello stesso stato. */
      if (this.cta) this.cta.hidden = this.inline || done;
      if (this.chosen) this.chosen.hidden = this.inline || !done;
      if (!done || !this.items) return;

      var self = this;
      var dots = this.querySelector('[data-mkp-dots]');
      var names = this.querySelector('[data-mkp-names]');
      var count = this.querySelector('[data-mkp-count]');

      if (dots) {
        dots.innerHTML = '';
        this.picked.forEach(function (i) {
          var s = document.createElement('span');
          var it = self.items[i];
          if (it && it.imgs.length) s.style.backgroundImage = 'url(' + sized(it.imgs[0], 90) + ')';
          dots.appendChild(s);
        });
      }
      if (names) {
        names.textContent = this.picked.map(function (i) { return self.items[i].t; }).join(' · ');
      }
      if (count) {
        count.textContent = this.slots === 1
          ? '1 tonalità scelta'
          : this.slots + ' tonalità scelte';
      }
    }
  }

  customElements.define('kit-picker', KitPicker);

  /* ==========================================================================
     Barra sticky in basso — solo mobile (<= 749px)
     Inizializzata dopo che il DOM è pronto, perché il markup della barra
     viene iniettato dallo snippet Liquid e non dal custom element.
     ========================================================================== */
  (function initStickyBar() {
    /* Breakpoint mobile: la barra non deve mai comparire su desktop */
    var MQ_MOBILE = window.matchMedia('(max-width: 749px)');

    function setup() {
      var bar = document.querySelector('[data-mkp-sticky-bar]');
      if (!bar || bar._mkpBarReady) return;
      bar._mkpBarReady = true;

      var sectionId = bar.dataset.section;
      var productId = bar.dataset.productId;

      /* Bottone "Aggiungi al carrello" reale del tema */
      var realBtn = document.getElementById('product-form-' + sectionId)
        ? document.getElementById('product-form-' + sectionId).querySelector('[name="add"]')
        : null;
      if (!realBtn) {
        realBtn = document.querySelector(
          'form[data-type="add-to-cart-form"][data-product-id="' + productId + '"] [name="add"]'
        );
      }
      if (!realBtn) return;

      /* Nodo prezzo del tema FoxTheme: il tema sostituisce i figli del nodo
         [role="status"] (id="price-template--...") a ogni cambio variante.
         Il MutationObserver deve osservare QUEL nodo (childList), non il
         .f-price figlio che viene ricreato. */
      var priceEl = document.querySelector('.product__block--price [role="status"]') ||
        document.querySelector('[id^="price-template"]') ||
        document.querySelector('.product__block--price');

      /* barPriceEl mantenuto per retrocompatibilità (vecchio markup con data-mkp-bar-price) */
      var barPriceEl = bar.querySelector('[data-mkp-bar-price]');
      var barStatusEl = bar.querySelector('[data-mkp-bar-status]');
      var barBtn = bar.querySelector('[data-mkp-bar-btn]');

      /* Istanza KitPicker associata a questa scheda */
      var picker = document.querySelector('kit-picker');

      /* ----------------------------------------------------------------
         Aggiornamento prezzo: copia il testo dal nodo prezzo del tema.
         MutationObserver è il metodo meno invasivo: non dipende dagli
         eventi interni del tema, funziona sia cambiando lampada sia
         cambiando numero di smalti.
         ---------------------------------------------------------------- */

      /* Guardia anti-rientro: evita il loop MutationObserver → syncPrice
         → scrittura DOM → MutationObserver → … */
      var _mkpSyncing = false;

      function syncPrice() {
        if (!priceEl) return;
        if (_mkpSyncing) return; /* già in esecuzione: esci subito */
        _mkpSyncing = true;
        /* Scollega l'observer PRIMA di qualunque scrittura nel DOM */
        if (priceObserver) priceObserver.disconnect();
        try {
        /* FoxTheme ricrea i figli del nodo [role="status"] a ogni cambio variante.
           Struttura con sconto:
             .f-price.f-price--on-sale
               .f-price__regular  → .f-price-item--regular (vuoto, nascosto)
               .f-price__sale
                 .f-price-item--sale    → prezzo scontato (es. €34,70)
                 .f-price-item--regular → contiene <s>€40,90</s> (prezzo barrato)
           Struttura senza sconto:
             .f-price (senza f-price--on-sale)
               .f-price__regular → .f-price-item--regular → prezzo pieno
        */
        var fPrice = priceEl.querySelector('.f-price') || priceEl;
        var isOnSale = fPrice.classList && fPrice.classList.contains('f-price--on-sale');

        var saleText = '';
        var compareText = '';

        if (isOnSale) {
          /* Prezzo scontato: dentro .f-price__sale > .f-price-item--sale */
          var saleNode = fPrice.querySelector('.f-price__sale .f-price-item--sale');
          if (saleNode) saleText = (saleNode.textContent || '').trim();

          /* Prezzo barrato: dentro .f-price__sale > .f-price-item--regular > s
             oppure direttamente .f-price-item--regular nel blocco sale */
          var compareNode = fPrice.querySelector('.f-price__sale .f-price-item--regular');
          if (compareNode) {
            var sTag = compareNode.querySelector('s');
            compareText = sTag
              ? (sTag.textContent || '').trim()
              : (compareNode.textContent || '').trim();
          }
        } else {
          /* Prezzo pieno: dentro .f-price__regular > .f-price-item--regular */
          var regularNode = fPrice.querySelector('.f-price__regular .f-price-item--regular');
          if (!regularNode) regularNode = fPrice.querySelector('.f-price-item--regular');
          if (regularNode) saleText = (regularNode.textContent || '').trim();
        }

        /* Fallback se tutto è vuoto */
        if (!saleText) {
          saleText = (fPrice.textContent || '').trim().split('\n')
            .map(function(l) { return l.trim(); })
            .filter(function(l) { return /[€$£¥]/.test(l); })[0] || '';
        }

        if (!saleText) return; /* Non sovrascrivere con stringa vuota */

        /* ----------------------------------------------------------------
           Badge sconto calcolato a runtime dai prezzi reali del DOM.
           Parsing formato italiano: "€1.234,56" → rimuove simbolo e
           separatori migliaia (punto), sostituisce virgola decimale con
           punto, poi parseFloat. Robusto anche su prezzi senza centesimi.
           ---------------------------------------------------------------- */
          (function updateBadge() {
            /* FIX P0: il badge viene inserito FUORI da priceEl (il nodo osservato)
               per spezzare il loop MutationObserver → syncPrice → mutazione DOM.
               Lo inseriamo come fratello di .f-price__sale dentro .f-price,
               così rimane sulla stessa riga del prezzo barrato (layout flex
               del tema invariato) ma non genera mutation record su priceEl. */
            var compareNode = fPrice.querySelector('.f-price__sale .f-price-item--regular');
            if (!compareNode) {
              /* Nessun prezzo barrato → nascondi il badge se esiste */
              var existing = fPrice.querySelector('[data-mkp-badge]');
              if (existing && !existing.hidden) existing.hidden = true;
              return;
            }

            /* Il badge è figlio di .f-price__sale (fuori da priceEl) */
            var badge = fPrice.querySelector('[data-mkp-badge]');
            if (!badge) {
              badge = document.createElement('span');
              badge.setAttribute('data-mkp-badge', '');
              badge.setAttribute('aria-hidden', 'true');
              /* Inserisce dopo .f-price-item--regular (prezzo barrato) */
              compareNode.parentNode.insertBefore(badge, compareNode.nextSibling);
            }

            /* Parsing prezzi: rimuove tutto tranne cifre, virgola e punto;
               poi elimina i punti separatori migliaia (es. "1.234" → "1234")
               e converte la virgola decimale in punto per parseFloat. */
            function parsePrice(str) {
              if (!str) return NaN;
              /* Rimuove simbolo valuta e spazi */
              var s = str.replace(/[€$£¥\s]/g, '');
              /* Se c'è sia punto che virgola: il punto è separatore migliaia */
              if (s.indexOf('.') > -1 && s.indexOf(',') > -1) {
                s = s.replace(/\./g, '').replace(',', '.');
              } else if (s.indexOf(',') > -1) {
                /* Solo virgola: è il decimale */
                s = s.replace(',', '.');
              }
              /* Rimuove eventuali caratteri residui non numerici */
              s = s.replace(/[^\d.]/g, '');
              return parseFloat(s);
            }

            var sale = parsePrice(saleText);
            var compare = parsePrice(compareText);

            /* Sconto valido: compare > sale e entrambi > 0 */
            if (!isFinite(sale) || !isFinite(compare) || compare <= sale || sale <= 0) {
              /* Write idempotente: assegna solo se cambia */
              if (!badge.hidden) badge.hidden = true;
              return;
            }

            var pct = Math.round((compare - sale) / compare * 100);
            if (pct <= 0) {
              if (!badge.hidden) badge.hidden = true;
              return;
            }

            /* Write idempotenti: evita mutation record inutili */
            var newText = '\u2212' + pct + '%'; /* −N% */
            if (badge.textContent !== newText) badge.textContent = newText;
            if (badge.hidden) badge.hidden = false;
          })();

          /* Aggiorna i nodi della barra sticky (write idempotenti) */
          var barSaleEl = bar.querySelector('[data-mkp-bar-sale]');
          var barRegularEl = bar.querySelector('[data-mkp-bar-regular]');

          if (barSaleEl && barSaleEl.textContent !== saleText) barSaleEl.textContent = saleText;
          if (barRegularEl && barRegularEl.textContent !== compareText) barRegularEl.textContent = compareText;

        } finally {
          /* Riconnette sempre l'observer, anche in caso di eccezione */
          if (priceObserver) priceObserver.observe(priceEl, { childList: true, subtree: true, characterData: true });
          _mkpSyncing = false;
        }
      }

      /* ----------------------------------------------------------------
         Stato colori: "2 di 4 colori scelti" / "Colori scelti"
         ---------------------------------------------------------------- */
      function syncStatus() {
        if (!barStatusEl) return;
        if (!picker) {
          barStatusEl.textContent = '';
          return;
        }
        var slots = picker.slots || 0;
        /* Mostra il massimo tra picked (confermati) e draft (in selezione):
           così il contatore si aggiorna anche mentre la modale è aperta,
           senza aspettare la conferma. */
        var source = picker.picked || [];
        if (picker.draft) {
          var draftCount = 0, pickedCount = 0, i;
          for (i = 0; i < picker.draft.length; i++) {
            if (picker.draft[i] !== null && picker.draft[i] !== undefined) draftCount++;
          }
          for (i = 0; i < source.length; i++) {
            if (source[i] !== null && source[i] !== undefined) pickedCount++;
          }
          if (draftCount > pickedCount) source = picker.draft;
        }
        var chosen = 0;
        for (var j = 0; j < source.length; j++) {
          if (source[j] !== null && source[j] !== undefined) chosen++;
        }
        if (slots === 0) {
          barStatusEl.textContent = '';
        } else if (chosen === slots) {
          barStatusEl.textContent = slots === 1 ? 'Colore scelto' : 'Colori scelti';
        } else if (chosen === 0) {
          barStatusEl.textContent = slots === 1 ? 'Colore da scegliere' : 'Colori da scegliere';
        } else {
          barStatusEl.textContent = chosen + ' di ' + slots + (slots === 1 ? ' colore scelto' : ' colori scelti');
        }
      }

      /* ----------------------------------------------------------------
         MutationObserver sul nodo prezzo del tema
         ---------------------------------------------------------------- */
      if (priceEl) {
        var priceObserver = new MutationObserver(function () {
          syncPrice();
        });
        priceObserver.observe(priceEl, { childList: true, subtree: true, characterData: true });
      }

      /* Sincronizzazione iniziale */
      syncPrice();
      syncStatus();

      /* Aggiorna lo stato colori quando il picker cambia (conferma) */
      document.addEventListener('kit-picker:change', function () {
        syncStatus();
      });

      /* Aggiorna anche a ogni cambio di variante (per il numero di slot) */
      ['variant:change', 'variantChange', 'product:variant-change'].forEach(function (ev) {
        document.addEventListener(ev, function () {
          picker = document.querySelector('kit-picker');
          syncStatus();
        });
      });

      /* MutationObserver sugli slot della modale: si aggiorna quando il JS
         del picker modifica gli slot (classe is-filled, background-image).
         Questo cattura i cambiamenti del draft in tempo reale. */
      var slotsEl = picker ? picker.querySelector('[data-mkp-slots]') : null;
      if (slotsEl) {
        var slotsObserver = new MutationObserver(function () {
          picker = document.querySelector('kit-picker');
          syncStatus();
        });
        slotsObserver.observe(slotsEl, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style', 'aria-current'] });
      }

      /* Polling leggero per lo stato colori (rete di sicurezza) */
      setInterval(function () {
        if (MQ_MOBILE.matches) syncStatus();
      }, 600);

      /* ----------------------------------------------------------------
         IntersectionObserver sul bottone reale
         La barra compare quando il bottone esce dal viewport (ratio < 1),
         sparisce quando torna visibile (ratio === 1).
         ---------------------------------------------------------------- */
      if (!MQ_MOBILE.matches) return; /* Desktop: non serve */

      /* ----------------------------------------------------------------
         Aggiorna la variabile CSS --mkp-bar-h e la classe body.mkp-bar-active
         in sincronia con la visibilità della barra.
         Aggiorna anche body.mkp-chat-expanded quando la chat Brevo è aperta.
         ---------------------------------------------------------------- */
      function setBarHeight() {
        var h = bar.offsetHeight || 64;
        document.documentElement.style.setProperty('--mkp-bar-h', h + 'px');
      }

      function showBar() {
        bar.classList.add('is-visible');
        bar.setAttribute('aria-hidden', 'false');
        setBarHeight();
        document.body.classList.add('mkp-bar-active');
      }

      function hideBar() {
        bar.classList.remove('is-visible');
        bar.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('mkp-bar-active');
      }

      /* MutationObserver sul contenitore Brevo: rileva quando la chat
         viene espansa (classe brevo-conversations--expanded) e aggiunge
         mkp-chat-expanded al body per nascondere la barra sticky.
         Il contenitore viene montato da brevo-conversations.js con
         id="brevo-conversations" dopo il caricamento del widget. */
      function watchBrevoChat() {
        /* Cerca #brevo-conversations ogni secondo per 30 secondi.
           Quando lo trova, attacca il MutationObserver sulla classe
           e smette di cercare. Approccio polling-only: più semplice
           e robusto del MutationObserver sul body (che non scatta
           se il nodo viene inserito da script asincroni o shadow DOM). */
        var _attached = false;
        var _poll = setInterval(function () {
          if (_attached) { clearInterval(_poll); return; }
          var el = document.getElementById('brevo-conversations');
          if (!el) return;
          _attached = true;
          clearInterval(_poll);
          attachBrevoObserver(el);
        }, 500);
        setTimeout(function () { clearInterval(_poll); }, 30000);
      }

      function attachBrevoObserver(brevoEl) {
        /* MutationObserver per rilevare l'espansione della chat in tempo reale */
        var brevoObs = new MutationObserver(function () {
          var expanded = brevoEl.classList.contains('brevo-conversations--expanded');
          document.body.classList.toggle('mkp-chat-expanded', expanded);
        });
        brevoObs.observe(brevoEl, { attributes: true, attributeFilter: ['class'] });
        /* Polling di supporto: il MutationObserver su attributi di classe
           non è garantito in tutti i contesti (es. script iniettati da iframe).
           Il polling è leggero (legge solo una proprietà booleana). */
        var _lastExpanded = brevoEl.classList.contains('brevo-conversations--expanded');
        document.body.classList.toggle('mkp-chat-expanded', _lastExpanded);
        setInterval(function () {
          var expanded = brevoEl.classList.contains('brevo-conversations--expanded');
          if (expanded !== _lastExpanded) {
            _lastExpanded = expanded;
            document.body.classList.toggle('mkp-chat-expanded', expanded);
          }
        }, 300);
      }

      watchBrevoChat();

      var io = new IntersectionObserver(function (entries) {
        var entry = entries[0];
        var visible = entry.intersectionRatio >= 0.5;
        if (visible) {
          hideBar();
        } else {
          showBar();
        }
      }, { threshold: [0, 0.5, 1] });

      io.observe(realBtn);

      /* Su resize: se si passa a desktop, nascondi la barra e smetti */
      MQ_MOBILE.addEventListener('change', function (e) {
        if (!e.matches) {
          hideBar();
          io.disconnect();
        } else {
          io.observe(realBtn);
          syncPrice();
        }
      });

      /* ----------------------------------------------------------------
         Clic sul bottone della barra:
         - Se la selezione è completa → click programmatico sul bottone reale
         - Se mancano colori → porta in vista il picker e mostra l'errore
         ---------------------------------------------------------------- */
      if (barBtn) {
        barBtn.addEventListener('click', function () {
          picker = document.querySelector('kit-picker');

          /* Selezione incompleta */
          if (picker && !picker.isComplete()) {
            /* Porta il picker a schermo */
            try {
              picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
            } catch (e) {
              picker.scrollIntoView();
            }
            /* Mostra l'errore esistente */
            var errEl = picker.querySelector('[data-mkp-errore]');
            if (errEl) {
              var slots = picker.slots || 0;
              var chosen = 0;
              if (picker.picked) {
                for (var j = 0; j < picker.picked.length; j++) {
                  if (picker.picked[j] !== null && picker.picked[j] !== undefined) chosen++;
                }
              }
              var mancano = slots - chosen;
              errEl.textContent = mancano === 1
                ? 'Scegli ancora 1 colore prima di aggiungere al carrello.'
                : 'Scegli ancora ' + mancano + ' colori prima di aggiungere al carrello.';
              errEl.hidden = false;
              /* Nasconde l'errore dopo 4 secondi */
              setTimeout(function () { errEl.hidden = true; }, 4000);
            }
            /* Nudge sugli slot vuoti (animazione esistente) */
            if (picker.inline && typeof picker.nudge === 'function') {
              picker.nudge();
            }
            return;
          }

          /* Selezione completa: inoltra il clic al bottone reale */
          realBtn.click();
        });
      }
    }

    /* Avvia dopo che il DOM è pronto */
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', setup);
    } else {
      /* Piccolo delay per assicurarsi che il custom element sia connesso */
      setTimeout(setup, 100);
    }
  })();

})();
